import { render, staticRenderFns } from "./OurStrength.vue?vue&type=template&id=dd00827c&scoped=true"
import script from "./OurStrength.vue?vue&type=script&lang=js"
export * from "./OurStrength.vue?vue&type=script&lang=js"
import style0 from "./OurStrength.vue?vue&type=style&index=0&id=dd00827c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd00827c",
  null
  
)

export default component.exports